import loaderSvgDefinition from '../svg-definitions/popup-loader-svg-definition.html';

class PopupFactory {
    popupLoaderMarkupBuilder(message) {
        return `
            ${loaderSvgDefinition}
            <div class="popup__content">
                <div class="loader--popup__spinner">
                    <svg>
                        <use href="#icon-compass2"></use>
                    </svg>
                    <div class="loader__message">
                        <span class="loader__text loader__text--dark">${message}</span>
                    </div>
                </div>
            </div>
        `;
    }
}

export default new PopupFactory();
